import { PlantOperationCapacityController } from './plant-operation-capacity.controller';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { PlantOperationCapacityService } from './plant-operation-capacity.service';
import { PlantOperationCapacity } from './plant-operation-capacity.entity';
import { PlantOperationCapacityAdapter } from './dto/plant-operation-capacity.adapter';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports:[
    TypeOrmModule.forFeature([ PlantOperationCapacity])
  ],
  controllers: [PlantOperationCapacityController],
  providers: [PlantOperationCapacityService,ApplicationExceptionHandler,PlantOperationCapacityAdapter,LogsService]
})
export class PlantOperationCapacityModule {}
